import { render, staticRenderFns } from "./TenancyLocationContacts.vue?vue&type=template&id=fbb7ac84&scoped=true&"
import script from "./TenancyLocationContacts.vue?vue&type=script&lang=js&"
export * from "./TenancyLocationContacts.vue?vue&type=script&lang=js&"
import style0 from "./TenancyLocationContacts.vue?vue&type=style&index=0&id=fbb7ac84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb7ac84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbb7ac84')) {
      api.createRecord('fbb7ac84', component.options)
    } else {
      api.reload('fbb7ac84', component.options)
    }
    module.hot.accept("./TenancyLocationContacts.vue?vue&type=template&id=fbb7ac84&scoped=true&", function () {
      api.rerender('fbb7ac84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/tenant/TenancyLocationContacts.vue"
export default component.exports